// JavaScript
// src/breweries/Breweries
// skipcq: JS-W1028, JS-0128
import React, { useState, useEffect } from 'react';
import { listUsers } from '../../utils/firebase';
//
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
// Components
import DashboardLayout from '../../components/layout/DashboardLayout';
import User from './User';

function Users() {
  const [users, setUsers] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const pageTitle = 'Users';

  /* function to get all tasks from firestore in realtime */
  useEffect(() => {
    let isSubscribed = true;

    const getUsers = async () => {
      const result = await listUsers();
      const { data } = result;
      if (data.error) {
        console.error(data.error);
        setError(true);
      }
      const { users: usersList } = data;
      // retrn users;
      if (isSubscribed) {
        setUsers(usersList);
        setLoading(false);
      }
    };
    getUsers().catch(console.error);

    return () => (isSubscribed = false);
  }, [setUsers]);

  return (
    <DashboardLayout title={pageTitle}>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "50vh"
          }}>
          <CircularProgress />
        </Box>
      ) : isError ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "50vh"
          }}>
          <Typography variant="h1">There was an error</Typography>
        </Box>
      ) : (
        <Grid
          container
          spacing={0}
          direction="column"
          justify="center"
          style={{ minHeight: '100vh' }}
          sx={{
            alignItems: "center"
          }}
        >
          {users.map((user) => (
            <User key={user.uid} user={user} />
          ))}
        </Grid>
      )}
    </DashboardLayout>
  );
}

export default Users;
